import React, { useContext, useState } from "react";
import { DealerListContext } from "../DealerListView";
import ContentData from "../../../../constants/contentFile.json";
import PluseIcon from "../../../../assets/images/pluse.svg";
import FilterIcon from "../../../../assets/images/icons/filter-icon.svg";
import SearchData from "../../../../components/SearchComponent/SearchData";
import { Container, Dropdown } from "react-bootstrap";
import DataTable from "../../../../components/TableComponent/DataTable";
import Loader from "../../../../components/Loader/Loader";
import PopupAlertError from "../../../../components/PopupAlertError/PopupAlertError";
import DropUpIcon from "../../../../assets/images/icons/dropup-icon.svg";
import DropDownIcon from "../../../../assets/images/icons/dropdown-icon.svg";
import ThemeButton from "../../../../components/ThemeButton/ThemeButton";
import "./dealerList.css";
const DealerList = () => {
  const {
    dealersList,
    header,
    onChangeSearch,
    searchData,
    spinnerStatus,
    onPageChange,
    pageCount,
    totalPage,
    addDealer,
    permissionAccess,
    errorPopup,
    errorPopupMessage,
    setErrorPopup,
    dealerToLogin,
    buttonText,
    dealersListAPI,
    statusValue,
    selectedStatusId,
    setSelectedStatusId,
    showDropdown,
    handleSelect,
    handleToggle,
    setStatus,
    onClickFilterButton,
  } = useContext(DealerListContext);
  const [isStatusExpanded, setIsStatusExpanded] = useState(false);
  const statuses = [
    { id: "A", name: "Active" },
    { id: "I", name: "Inactive" },
  ];
  return (
    <div className="pageBg dealer-list">
      <div className="breadCrums boldBreadCrums">
        <span>{ContentData.DealerPage.pageTitle}</span>
      </div>
      <Container>
        {spinnerStatus && <Loader />}
        <div className="pageTittles-dealer-list">
          {ContentData.DealerPage.pageTitle}
        </div>
        <div className="searchAddSection adminRole">
          <div className="searchSection">
            <SearchData
              placeholder={ContentData.DealerPage.searchData}
              value={searchData}
              onChange={onChangeSearch}
              type="text"
            />
          </div>
          <div className="plusRefreshDtat">
            <Dropdown
              autoClose="outside"
              show={showDropdown}
              onToggle={handleToggle}
            >
              <Dropdown.Toggle
                variant="link"
                id="dropdown-basic"
                className="custom-dropdown-toggle"
              >
                <div className="adminFilterIcon">
                  <img src={FilterIcon} alt="filter" />
                </div>
              </Dropdown.Toggle>

              <Dropdown.Menu
                className="admin-dropdown-menu "
                style={{
                  backgroundColor: "#F7F8FA",
                  width: "258px",
                  marginTop: "34px",
                }}
              >
                <Dropdown.Item className="dropdown-filter-clear">
                  <span className="filter-text">
                    {ContentData.productPage.filter}
                  </span>
                  <span
                    className="clear-all"
                    onClick={() => {
                      handleSelect();
                      setStatus("");
                      setSelectedStatusId("");
                    }}
                  >
                    {ContentData.productPage.clearAll}
                  </span>
                </Dropdown.Item>

                <Dropdown.Item
                  className={`firstItem dropdownItem ${
                    isStatusExpanded ? "expanded" : ""
                  }`}
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsStatusExpanded(!isStatusExpanded);
                  }}
                  style={{
                    borderBottom: "0",
                  }}
                >
                  Status
                  <img
                    src={isStatusExpanded ? DropUpIcon : DropDownIcon}
                    alt="toggle"
                  />
                </Dropdown.Item>

                {/* Status items */}
                {isStatusExpanded &&
                  statuses.map((status) => (
                    <Dropdown.Item
                      className={`dropdownItem status-item ${
                        selectedStatusId === status.id ? "selected" : ""
                      }`}
                      key={status.id}
                      onClick={(e) => {
                        e.stopPropagation();
                        const newStatusId =
                          selectedStatusId === status.id ? "" : status.id;
                        setSelectedStatusId(newStatusId);
                      }}
                      style={{
                        paddingLeft: "20px",
                        height: "48px",
                      }}
                    >
                      {status.name}
                    </Dropdown.Item>
                  ))}

                {/* Apply Button */}
                <Dropdown.Item className="dropdownItem status-item tenantThemeBtn">
                  <ThemeButton
                    value={"Apply"}
                    className={""}
                    onClick={() => {
                      onClickFilterButton(selectedStatusId);
                    }}
                  />
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            <div
              className={`addProduct  addDataProduct ${
                permissionAccess?.add ? "" : "disabledMainButton"
              } `}
              onClick={() => addDealer()}
            >
              <img src={PluseIcon} alt="add" />
              <span>{ContentData.DealerPage.addDealer}</span>
            </div>
          </div>
        </div>
        <div className="basicContainer roleListTable">
          <DataTable
            tableData={dealersList}
            header={header}
            onPageChange={(e) => onPageChange(e)}
            isPagination={true}
            currentPage={pageCount}
            pageCount={totalPage}
          />
        </div>
      </Container>
      <PopupAlertError
        show={errorPopup}
        alertMessage={errorPopupMessage}
        buttonText={buttonText}
        status={statusValue}
        handleCancel={() => setErrorPopup(false)}
        handleSubmit={() => {
          if (statusValue === 401 || statusValue === 403) {
            dealerToLogin();
            setErrorPopup(false);
          } else {
            setErrorPopup(false);
            dealersListAPI(pageCount, searchData);
          }
        }}
        errorAlertOnly={statusValue === 400 ? true : false}
      />
    </div>
  );
};

export default DealerList;
